export const GUIDE_STATUS_QUERY_KEY = ['guide-status'];
